import React, { useContext, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Outlet,
} from "react-router-dom";

import AuthContext, {
  AuthContextProvider,
  LoaderProvider,
} from "./AuthContext/AuthContext";
import Login from "./Pages/Auth/Login/Login";
import Home from "./Pages/Home/Home";
import LoginOTP from "./Pages/Auth/LoginOTP/LoginOTP";
import Register from "./Pages/Auth/Register/Register";
import CheckPaymentStatus from "./Components/Phone Pay/PaymentSuccess";
import RegisterOTP from "./Pages/Auth/RegisterOTP/RegisterOTP";
import AboutUsPage from "./Pages/AboutUsPage/AboutUsPage";
import ContactUsPage from "./Pages/ContactUsPage/ContactUsPage";
import Blogs from "./Pages/BlogsPage/Blogs";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/FooterSection/FooterSection";
import MyStore from "./Components/My Store/MyStore";
import Cart from "./Components/My Store/Cart";
import ViewCart from "./Components/My Store/ViewCart";
import Checkout from "./Components/My Store/Checkout";
import ThankYou from "./Components/Thank You/ThankYou";
import BookPandit from "./Pages/BookPandit/BookPandit";
import PoojsDetails from "./Components/PoojaDetails/PujaDetails";
import PanditList from "./Components/PanditList/PanditList";
import MyOrder from "./Components/My Store/MyOrder";
import OrderDetails from "./Components/My Store/OrderDetails";
import ScrollToTop from "./Components/ScrollToTop";
import ServiceList from "./Components/Service Order/ServiceList";
import DarshanBookingList from "./Components/Darshan Booking/DarshanBookingList";
import MyProfile from "./Components/My Profile/MyProfile";
import HoroscopeListCards from "./Components/Horoscope/HoroscopeListCards";
import TempleBookingForm from "./Components/Darshan Booking/TempleBookingForm";
import AstrologyList from "./Components/Horoscope/Astrology/AstrologyList";
import StepperForm from "./Pages/Stepper Form/StepperForm";
import PanditBooking from "./Pages/PanditBooking/PanditBooking";
import MyPanditBookingOrders from "./Pages/PanditBooking/MyPanditBookingOrders";
import PBOrderDetails from "./Pages/PanditBooking/PBOrderDetails";
import DailyBooking from "./Pages/DailyBooking/DailyBooking";
import DailyBookingDetails from "./Pages/DailyBooking/DailyBookingDetails";
import DailyPujaBooking from "./Pages/DailyBooking/DailyPujaBooking";
import DailyBookingOrders from "./Pages/DailyBooking/DailyBookingOrders";
import DBOrderDetails from "./Pages/DailyBooking/DailyBookingOrderDetails";
import TempleDetails from "./Components/Darshan Booking/TempleDetails";
import PoojaAtTempleList from "./Components/Puja At Temple/PoojaAtTemple";
import PujaAtTempleBookingForm from "./Components/Puja At Temple/PujaAtTempleBookingForm";
import PoojaAtTempleDetails from "./Components/Puja At Temple/PoojaAtTempleDetails";
import DarshanBookingOrderList from "./Components/Darshan Booking/DarshanBookingOrderList";
import DarshanBookingOrderDetails from "./Components/Darshan Booking/DarshanBookingOrderDetails";
import PujaAtTempleBookingOrderList from "./Components/Puja At Temple/PujaAtTempleBookingOrderList";
import PujaAtTempleOrderDetails from "./Components/Puja At Temple/PujaAtTempleOrderDetails";
import ServicesLandingPage from "./Pages/ServicesLandingPage/ServicesLandingPage";
import BasicDetails from "./Components/Horoscope/Astrology/BasicDetails";
import DailyPrediction from "./Components/Horoscope/DaliyPrediction/DailyPrediction";
import DailyPanchang from "./Components/Horoscope/DailyPanchang/DailyPanchang";
import Numerology from "./Components/Horoscope/Numerology/Numerology";
import Prediction from "./Components/Horoscope/Prediction/Prediction";
import BlogPost from "./Pages/BlogsPage/BlogPost";
import Invoice from "./Components/Invoice";
import LoginPopUp from "./Components/LoginPopup";
import FAQPage from "./Pages/FAQs/FAQsPage";
import BecomePandit from "./Pages/BecomePandit/BecomePandit";
import TempleDarshanInvoice from "./Components/Darshan Booking/TempleDarshanInvoice";
import PujaAtTempleInvoice from "./Components/Puja At Temple/PujaAtTempleInvoice";
import CommonBlogPage from "./Pages/BlogsPage/CommonBlogPage";
import ReceiptDetailsPage from "./Components/ReceiptDetailsPage";
import ViewReceipt from "./Components/ViewReceipt";
import EStoreInvoice from "./Components/E-StoreInvoice";
import { HelmetProvider } from "react-helmet-async";
import PrivacyPolicyPage from "../src/Components/PrivacyPolicy/PrivacyPolicyPage";
import TermsAndConditionPage from "../src/Components/TermsAndConditon/TermsAndConditionPage";
import PrasadList from "../src/Components/Prasad/PrasadList";
import PrasadDetails from "../src/Components/Prasad/PrasadDetails";
import ViewPrasadCart from "../src/Components/Prasad/ViewPrasadCart";
import DownloadApp from "../src/Components/DownLoadApp/DownloadApp";
import CounterSection from "../src/Components/DownLoadApp/CounterSection";
import PrasadOrderPage from "../src/Components/Prasad/PrasadOrderPage";
import PrasadOrderDetails from "../src/Components/Prasad/PrasadOrderDetails";
import Loader from "./Components/Loader";
import NotFoundPage from "./Components/NotFoundPage";
import RefundPolicy from "./Components/Refund Policy/RefundPolicy";
import TempleList from "./Components/Temple/TempleList";
import TempleListDetails from "./Components/Temple/TempleDetails";
import WalletList from "./Components/Wallet/WalletList";
import Breadcrumbs from "./Components/Breadcrumb";
import PujaKitDetailsPage from "./Components/PujaKitSubscription/PujaKitDetailsPage";
import PujaKitSubscriptionOrders from "./Components/PujaKitSubscription/PujaKitSubscriptionOrders";
import PujaOrdersDetailsPage from "./Components/PujaKitSubscription/PujaOrdersDetailsPage";
import ReferAndEarn from "./Components/ReferAndEarn/ReferAndEarnHistory";
import WebinarLandingPage from "./Pages/Webinar/WebinarLandingPage";
import Webinarmarathi from "./Pages/Webinar/Webinarmarathi";
import GanapatiVisarjanLandingPage from "./Pages/GanapatiVisarjanLandingPage/GanapatiVisarjanLandingPage";
import GanapatiVisarjanOrderListPage from "./Pages/GanapatiVisarjanLandingPage/GanapatiVisarjanOrderListPage";
import GanapatiVisarjanOrderDetails from "./Pages/GanapatiVisarjanLandingPage/GanapatiVisarjanOrderDetails";
import MakharCompetitionLandingPage from "./Pages/MakharCompetition/MakharCompetitionLandingPage";
import WhyChooseUs from "./Components/WhyChooseUs/WhyChooseUs";
import PujaServicesLandingPage from "./Pages/RemedyPuja/PujaServicesLandingPage";
import RemedyPujaListPage from "./Pages/RemedyPuja/RemedyPujaListPage";
import PanditPujaListPage from "./Pages/RemedyPuja/PanditPujaListPage";
import RemedyPujaDetails from "./Pages/RemedyPuja/RemedyPujaDetails";
import PujaBookingFormSection from "./Pages/RemedyPuja/PujaBookingFormSection";
import PujaOrderListPage from "./Pages/RemedyPuja/PujaOrderListPage";
import RemedyPujaOrderPage from "./Pages/RemedyPuja/RemedyPujaOrderPage";
import RemedyPujaOrderDetails from "./Pages/RemedyPuja/RemedyPujaOrderDetails";

import PitrupakshaWebinar from "./Pages/Webinar/PitrupakshaWebinar";
import WebinarThanku from "./Pages/Webinar/WebinarThanku";
import PitrupakshaWebinarHindi from "./Pages/Webinar/PitrupakshaWebinarHindi";
import WebinarThankuHindi from "./Pages/Webinar/WebinarThankuHindi";
import CommonHoroscopePage from "./Components/Horoscope/CommonHoroscopePage/CommonHoroscopePage";
import TemplePujaList from "./Components/TemplePujaList/TemplePujaList";
// -----------------
import PujasListPage from "./Components/Puja/PujasListPage";
import AshtaLakshmiHomamWebinar from "./Pages/Webinar/AshtaLakshmiHomamWebinar";
import WebinarThankuAshtalakshmi from "./Pages/Webinar/WebinarThankuAshtalakshmi";
import DhanaAkarshanaHomam from "./Pages/Webinar/DhanaAkarshanaHomam";
import DhanaAkarshanaThankYou from "./Pages/Webinar/DhanaAkarshanaThankYou";
import ProductKitSubscriptionBooking from "./Components/My Store/PujaKitSubscriptionBooking";
import SatyanarayanaPoojaWebinar from "./Pages/Webinar/SatyanarayanaPoojaWebinar";

const App = () => {
  const { setLoader, setIsAuthenticated, isAuthenticated } =
    useContext(AuthContextProvider);
  const updateAuthStatus = () => {
    setIsAuthenticated(!!localStorage.getItem("userID") && !!localStorage.getItem("token"));
    // setIsAuthenticated(!!localStorage.getItem("username"));
  };

  useEffect(() => {
    updateAuthStatus(); // Sync state with localStorage on load
    window.addEventListener("storage", updateAuthStatus); // Sync across tabs/windows
    return () => window.removeEventListener("storage", updateAuthStatus);
  }, []);

  useEffect(() => {

    if (window.location.pathname === "/Register") {
      localStorage.clear()
      const params = new URLSearchParams(window.location.search);

      const refCode = params.get("RefCode");
      const from = params.get("From");

      if (refCode) {
        localStorage.setItem("referralCode", refCode);
      }

      if (from) {
        localStorage.setItem("referralFrom", from);
      }
    }
  }, []);


  const Layout = () => {
    return (
      <>
        <Navbar />
        <main style={{ paddingTop: "100px" }}>
          {/* <div style={{ paddingTop: "30px", marginLeft: "20px" }}>
            <Breadcrumbs />
          </div> */}
          {/* <hr /> */}
          <Outlet /> {/* This will render the current page */}
        </main>
        <Footer />
      </>
    );
  };

  const AuthHandler = () => {
    const { setIsAuthenticated } = useContext(AuthContextProvider);
    const location = useLocation();

    // useEffect(() => {
    //   if (location.pathname === "/logout") {
    //     localStorage.clear();
    //     setIsAuthenticated(false);
    //   } else if (location.pathname === "/") {
    //     document.title = "Home /Om namo";
    //   } else if (location.pathname === "/services/puja-booking") {
    //     document.title = "Puja Booking Service";
    //   } else if (location.pathname === "/services/daily-puja-booking") {
    //     document.title = "Daily Puja Booking Service";
    //   } else if (location.pathname === "/services/e-store") {
    //     document.title = "E-store Booking Service";
    //   } else if (location.pathname === "/services/darshan-booking") {
    //     document.title = "Darshan Booking Service";
    //   } else if (location.pathname === "/services/temple-puja") {
    //     document.title = "Temple Puja Booking Service";
    //   } else if (location.pathname === "/services/horoscope") {
    //     document.title = "Horoscope Service";
    //   } else {
    //     document.title = "Complete Spiritual Services Online";
    //   }
    // }, [location.pathname]);

    return null; // This component doesn't render anything, it just handles auth logic
  };


  const { loader } = useContext(AuthContextProvider);
  const ProtectedRoute = ({ element }) => {
    // const { isAuthenticated } = useContext(AuthContext);
    const location = useLocation();
    const [showLogin, setShowLogin] = useState(false);

    useEffect(() => {
      if (!isAuthenticated) {
        setShowLogin(true); // Show login popup when user is not authenticated
      }
    }, [isAuthenticated]); // Runs when authentication status changes

    if (!isAuthenticated) {
      return <LoginPopUp show={showLogin} onHide={() => setShowLogin(false)} />;
    }

    return element;
  };

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <AuthHandler />
        <LoaderProvider>
          <Routes>
            {/* Main layout route */}
            <Route
              path="check-payment-status/:slug"
              element={<CheckPaymentStatus />}
            />
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route
                path="/ganesh-visarjan"
                element={<GanapatiVisarjanLandingPage />}
              />
              {/* <Route
                path="/makhar-competition"
                element={<MakharCompetitionLandingPage />}
              /> */}
              <Route
                path="/ganapati-visarjan-orders"
                element={<ProtectedRoute element={<GanapatiVisarjanOrderListPage />} />}
              />
              <Route
                path="/ganapati-visarjan-orders-details"
                element={<ProtectedRoute element={<GanapatiVisarjanOrderDetails />} />}
              />
              {/* <Route path="register" element={<Register />} /> */}
              <Route path="registerotp" element={<RegisterOTP />} />
              <Route path="checkout" element={<ProtectedRoute element={<Checkout />} />} />
              <Route path="my-store" element={<MyStore />} />
              <Route path="my-store/:id" element={<MyStore />} />
              <Route path="product-details/:slug" element={<Cart />} />
              <Route path="darshan-booking" element={<DarshanBookingList />} />
              <Route path="temple/:slug" element={<TempleDetails />} />
              <Route path="horoscope" element={<HoroscopeListCards />} />
              <Route path="blog-post" element={<BlogPost />} />
              <Route path="contact-us" element={<ContactUsPage />} />
              <Route path="about-us" element={<AboutUsPage />} />
              <Route path="faq" element={<FAQPage />} />
              <Route path="astrology-list" element={<AstrologyList />} />
              <Route path="stepper-form" element={<StepperForm />} />
              <Route path="services/book-puja" element={<BookPandit />} />
              <Route
                path="services/online-puja/:slug"
                element={<BookPandit />}
              />
              <Route path="services/daily-booking" element={<DailyBooking />} />
              <Route
                path="services/:servicename"
                element={<ServicesLandingPage />}
              />
              <Route path="basic-details" element={<BasicDetails />} />
              <Route path="daily-prediction" element={<DailyPrediction />} />
              <Route path="spiritual-gyan/:slug" element={<Blogs />} />
              <Route path="spiritual-gyan" element={<CommonBlogPage />} />
              <Route path="prasad-order" element={<ProtectedRoute element={<PrasadOrderPage />} />} />
              <Route path="/temples" element={<TempleList />} />
              <Route
                path="/Terms-And-Condition"
                element={<TermsAndConditionPage />}
              />

              {/* Add your authenticated routes conditionally here as needed */}

              <Route path="become-pandit" element={<BecomePandit />} />
              <Route path="wallet" element={<ProtectedRoute element={<WalletList />} />} />
              <Route
                path="/services/book-puja/:slug"
                element={<PoojsDetails />}
              />
              <Route
                path="/service/puja-details/:slug"
                element={<RemedyPujaDetails />}
              />
              <Route
                path="/service/remedy-puja-details/:slug"
                element={<RemedyPujaDetails />}
              />
              <Route
                path="/service/homam-puja-details/:slug"
                element={<RemedyPujaDetails />}
              />
              <Route
                path="/service/subscription-homam-puja-details/:slug"
                element={<RemedyPujaDetails />}
              />
              <Route
                path="/service/subscription-remedy-puja-details/:slug"
                element={<RemedyPujaDetails />}
              />
              <Route
                path="/service/pandit-puja-details/:slug"
                element={<RemedyPujaDetails />}
              />
              <Route
                path="/service/daily-pandit-puja-details/:slug"
                element={<RemedyPujaDetails />}
              />
              <Route
                path="services/book-puja/puja-details"
                element={<PoojsDetails />}
              />
              <Route path="/puja-book" element={<PujasListPage />} />
              <Route
                path="services/daily-booking/puja-details/:slug"
                element={<DailyBookingDetails />}
              />
              <Route
                path="services/daily-puja/add-service"
                element={<DailyPujaBooking />}
              />
              <Route
                path="services/book-puja/add-service"
                element={<PanditBooking />}
              />
              <Route
                path="temple-darshan-invoice"
                element={<ProtectedRoute element={<TempleDarshanInvoice />} />}
              />
              <Route
                path="puja-at-temple-invoice"
                element={<ProtectedRoute element={<PujaAtTempleInvoice />} />}
              />
              <Route
                path="my-order-puja-booking"
                element={<ProtectedRoute element={<MyPanditBookingOrders />} />}
              />
              <Route
                path="my-order-daily-Booking"
                element={<ProtectedRoute element={<DailyBookingOrders />} />}
              />
              <Route
                path="my-order-remedy-Booking"
                element={<ProtectedRoute element={<RemedyPujaOrderPage />} />}
              />
              <Route
                path="/my-order-homam-Booking"
                element={<ProtectedRoute element={<RemedyPujaOrderPage />} />}
              />
              <Route
                path="order-details"
                element={<ProtectedRoute element={<RemedyPujaOrderDetails />} />}
              />
              <Route path="view-cart" element={<ProtectedRoute element={<ViewCart />} />} />
              <Route path="my-order" element={<ProtectedRoute element={<MyOrder />} />} />
              <Route path="prasad-list" element={<PrasadList />} />
              <Route path="remedy-puja" element={<RemedyPujaListPage />} />
              <Route path="homam-puja" element={<RemedyPujaListPage />} />
              <Route
                path="remedy-subscription-puja"
                element={<RemedyPujaListPage />}
              />
              <Route
                path="homam-subscription-puja"
                element={<RemedyPujaListPage />}
              />
              <Route
                path="daily-pandit-puja"
                element={<RemedyPujaListPage />}
              />
              <Route path="pandit-puja" element={<PanditPujaListPage />} />
              <Route path="prasad-details/:slug" element={<PrasadDetails />} />
              <Route
                path="prasad-order-details"
                element={<ProtectedRoute element={<PrasadOrderDetails />} />}
              />
              <Route path="prasad-cart" element={<ProtectedRoute element={<ViewPrasadCart />} />} />
              <Route path="/product-order-details" element={<ProtectedRoute element={<OrderDetails />} />} />
              <Route path="/" element={<Home />} />
              <Route path="/Register" element={<Home />} />
              <Route path="/about-us" element={<AboutUsPage />} />
              <Route path="/contact-us" element={<ContactUsPage />} />
              <Route path="/spiritual-gyan/:slug" element={<Blogs />} />
              <Route path="/spiritual-gyan" element={<CommonBlogPage />} />
              <Route path="/blog-post" element={<BlogPost />} />
              <Route path="/my-store" element={<MyStore />} />
              <Route path="/my-store/:id" element={<MyStore />} />
              <Route path="/temple/:slug" element={<TempleDetails />} />
              <Route path="/product-details" element={<Cart />} />
              <Route path="/checkout" element={<ProtectedRoute element={<Checkout />} />} />
              <Route path="/invoice" element={<ProtectedRoute element={<Invoice />} />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

              <Route
                path="/services/book-puja/puja-details"
                element={<PoojsDetails />}
              />
              <Route
                path="/puja-kit-details"
                element={<PujaKitDetailsPage />}
              />
              <Route
                path="/services/book-puja/puja-details/pandit-list"
                element={<PanditList />}
              />
              <Route path="/view-cart" element={<ProtectedRoute element={<ViewCart />} />} />
              {/* <Route path="/login" element={<Login />} />
              <Route path="/loginotp" element={<LoginOTP />} /> */}
              <Route path="/thank-you" element={<ThankYou />} />
              {/* <Route path="/services/book-puja" element={<BookPandit />} /> */}
              {/* <Route path="/register" element={<Register />} /> */}
              <Route path="/my-order" element={<ProtectedRoute element={<MyOrder />} />} />
              <Route
                path="/puja-Booking-order-details"
                element={<ProtectedRoute element={<PBOrderDetails />} />}
              />
              <Route
                path="/daily-Booking-order-details"
                element={<ProtectedRoute element={<DBOrderDetails />} />}
              />
              <Route path="/order-details" element={<ProtectedRoute element={<OrderDetails />} />} />
              <Route path="/my-profile" element={<ProtectedRoute element={<MyProfile />} />} />
              <Route path="/horoscope/my-profile" element={<ProtectedRoute element={<MyProfile />} />} />
              <Route path="/my-order-list" element={<ProtectedRoute element={<ServiceList />} />} />
              <Route
                path="/temple-booking-form"
                element={<TempleBookingForm />}
              />
              <Route
                path="/puja-kit-booking"
                element={<ProductKitSubscriptionBooking />}
              />
              <Route path="/astrology-list" element={<AstrologyList />} />
              <Route path="/stepper-form" element={<StepperForm />} />
              <Route path="/puja-at-temple" element={<PoojaAtTempleList />} />
              <Route
                path="/puja-at-temple-booking"
                element={<PujaAtTempleBookingForm />}
              />
              <Route
                path="/puja-at-temple/:slug"
                element={<PoojaAtTempleDetails />}
              />
              <Route
                path="/my-order-darshan-Booking"
                element={<ProtectedRoute element={<DarshanBookingOrderList />} />}
              />
              <Route path="/e-store-invoice" element={<ProtectedRoute element={<EStoreInvoice />} />} />
              <Route
                path="/darshan-order-details"
                element={<ProtectedRoute element={<DarshanBookingOrderDetails />} />}
              />
              <Route
                path="/my-order-puja-At-Temple"
                element={<ProtectedRoute element={<PujaAtTempleBookingOrderList />} />}
              />
              <Route
                path="/order-details-puja-At-Temple"
                element={<ProtectedRoute element={<PujaAtTempleOrderDetails />} />}
              />
              <Route
                path="/services/:servicename"
                element={<ServicesLandingPage />}
              />
              <Route
                path="/service/:servicename"
                element={<PujaServicesLandingPage />}
              />
              <Route
                path="/service/puja-service/booking-form"
                element={<PujaBookingFormSection />}
              />
              <Route path="/my-orders" element={<ProtectedRoute element={<PujaOrderListPage />} />} />

              <Route path="/basic-details" element={<BasicDetails />} />
              <Route path="/daily-prediction" element={<DailyPrediction />} />
              <Route path="/daily-panchang" element={<DailyPanchang />} />
              <Route path="/numerology" element={<Numerology />} />
              <Route path="/prediction" element={<Prediction />} />
              <Route path="/receipt-details" element={<ProtectedRoute element={<ReceiptDetailsPage />} />} />
              <Route path="/view-receipt" element={<ProtectedRoute element={<ViewReceipt />} />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/temple-details" element={<TempleListDetails />} />
              <Route path="/:slug" element={<TempleListDetails />} />
              <Route path="/temple-puja" element={<TemplePujaList />} />
              <Route
                path="/horoscope-detail"
                element={<CommonHoroscopePage />}
              />
              <Route
                path="/puja-kit-orders"
                element={<ProtectedRoute element={<PujaKitSubscriptionOrders />} />}
              />
              <Route
                path="/puja-kit-order-details"
                element={<ProtectedRoute element={<PujaOrdersDetailsPage />} />}
              />
              <Route path="/refer-and-earn" element={<ProtectedRoute element={<ReferAndEarn />} />} />
              <Route path="/why-choose-us" element={<WhyChooseUs />} />
              {/* ... other authenticated routes ... */}
            </Route>

            {/* ✅ Global 404 handler for any unmatched route */}
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/page-not-found" element={<NotFoundPage />} />
            <Route path="/webinar" element={<WebinarLandingPage />} />
            <Route path="/m-webinar" element={<Webinarmarathi />} />
            <Route
              path="/pitrupaksha-webinar"
              element={<PitrupakshaWebinar />}
            />
            <Route path="/webinar-thanku" element={<WebinarThanku />} />
            <Route
              path="/pitrupaksha-webinar-hindi"
              element={<PitrupakshaWebinarHindi />}
            />
            <Route
              path="/webinar-thanku-hindi"
              element={<WebinarThankuHindi />}
            />
            <Route
              path="/ashtalakshmi-homam-webinar"
              element={<AshtaLakshmiHomamWebinar />}
            />
            <Route
              path="/satyanarayana-pooja"
              element={<SatyanarayanaPoojaWebinar />}
            />
            <Route
              path="/webinar-thanku-ashtalakshmi"
              element={<WebinarThankuAshtalakshmi />}
            />
            <Route
              path="/thank-you-dhana-akarshana-homam"
              element={<DhanaAkarshanaThankYou />}
            />
            <Route
              path="/dhana-akarshana-homam"
              element={<DhanaAkarshanaHomam />}
            />
          </Routes>
        </LoaderProvider>
      </Router>
    </HelmetProvider>
  );
};

export default App;
